<script setup lang="ts">
  import { useUiStore } from '@/stores/ui'
  import { storeToRefs } from 'pinia'

  const ui = useUiStore()
  const { cookieToastState, cookieAccepted } = storeToRefs(ui)

  function close() {
    cookieAccepted.value = true
    ui.toggleCookieToast()
  }
</script>

<template>
  <transition name="fade">
    <div
      v-if="cookieToastState.visibility"
      class="fixed bottom-[92px] md:bottom-[26px] left-1/2 -translate-x-1/2 toast pointer-events-auto w-[500px] max-w-[calc(100%-40px)] z-40 border-l-1 border-black bg-white flex items-center justify-between py-4 px-8"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      @click.prevent="close"
    >
      <div class="break-words text-sm">
        SEEN использует cookie. Полная информация содержится в
        <router-link
          class="underline hover:no-underline"
          :to="{ name: 'customer-privacy-policy' }"
        >
          правилах по обработке персональных данных</router-link
        >.<br />
        Вы можете запретить сохранение cookie в настройках вашего браузера.
      </div>

      <!-- Close Button -->
      <div>
        <button aria-label="close" class="close cursor-pointer">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 12L12 4M12 12L4 4"
              stroke="#7A7A7A"
              stroke-width="1.2"
              stroke-linecap="square"
            />
          </svg>
        </button>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s linear;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

  .toast {
    border-left: 1px solid #000000;
    box-shadow: 0 2px 9px rgba(0, 0, 0, 0.17);
  }
</style>
